module.exports = __webpack_public_path__ + "img/arrow-up.07ffea8e.svg";